import { styled } from 'styled-components';

export const TabAdjuster = styled.div`
  position: relative;

  button {
    margin: ${({ theme }) => theme.sizing.tiny}
      ${({ theme }) => theme.sizing.xlarge} ${({ theme }) => theme.sizing.tiny}
      0;
  }

  div[role='tablist'] {
    div[role='tab']:nth-child(2) {
      button {
        margin-right: ${({ $showTwo }) => ($showTwo ? '2rem' : '0')};
      }
    }

    div[role='tab']:nth-child(3) {
      button {
        margin-right: ${({ $showThree }) => ($showThree ? '2rem' : '0')};
      }
    }
  }
`;
TabAdjuster.displayName = 'TabAdjuster';

export const TabRoundel = styled.div`
  font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
  border-radius: 50%;
  padding: ${({ theme }) => theme.sizing.tiny}
    ${({ theme }) => theme.sizing.xsmall} ${({ theme }) => theme.sizing.tiny};
  background-color: ${({ theme }) => theme.colours.messaging.info.main};
  color: ${({ theme }) => theme.colours.messaging.info.ink};
  line-height: 1;
  position: absolute;
  z-index: 100;
  font-weight: bold;
  opacity: ${({ $opacity }) => $opacity || 1};

  &:hover {
    cursor: pointer;
  }
`;
TabRoundel.displayName = 'TabRoundel';

export const TabSequence = styled.div`
  div {
    top: 11px;
  }
  div[id='general-tab-roundel'] {
    left: 72px;
  }
  div[id='biometrics-tab-roundel'] {
    left: 138px;
  }
  div[id='stats-tab-roundel'] {
    left: ${({ $showThreeAlt }) => ($showThreeAlt ? '205px' : '230px')};
  }
`;
TabSequence.displayName = 'TabSequence';
